import React from 'react';
import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export function DateDisplay({ 
  currentDate, 
  onPreviousWeek, 
  onNextWeek 
}) {
  const formatDateFull = (date) => {
    const weekdayFormatter = new Intl.DateTimeFormat('es-ES', { weekday: 'long' });
    const weekday = weekdayFormatter.format(date);
    const capitalizedWeekday = weekday.charAt(0).toUpperCase() + weekday.slice(1);

    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yy = String(date.getFullYear()).slice(-2);

    return `${capitalizedWeekday} · ${dd}/${mm}/${yy}`;
  };

  const capitalizedDate = formatDateFull(currentDate);

  return (
    <div className="w-full pt-1 pb-0 px-4">
      <div className="container_max_w mx-auto flex items-center justify-center gap-4 sm:gap-6">
        {/* Flecha Izquierda */}
         <Button
            variant="ghost"
            size="icon"
            onClick={onPreviousWeek}
            className="text-primary hover:bg-transparent hover:text-primary h-9 w-9 flex-shrink-0"
            aria-label="Semana anterior"
          >
          <ChevronLeft className="h-5 w-5" />
        </Button>

        {/* Fecha Centrada */}
        <p className="text-sm sm:text-base font-semibold text-foreground text-center whitespace-nowrap">
          {capitalizedDate}
        </p>

        {/* Flecha Derecha */}
        <Button
          variant="ghost"
          size="icon"
          onClick={onNextWeek}
          className="text-primary hover:bg-transparent hover:text-primary h-9 w-9 flex-shrink-0"
          aria-label="Semana siguiente"
        >
          <ChevronRight className="h-5 w-5" />
        </Button>
      </div>
    </div>
  );
}
